import React, { Component } from "react";
import { StaticQuery, graphql, Link} from 'gatsby'
import { translate } from "react-i18next"


class Beta extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.state = 
    {
        message: "",
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  render() {
    const { t } = this.props
    return (
      <StaticQuery
        query={graphql`
          query BetaQuery {
            site {
              siteMetadata {
                shortTitle
                version
              }
            }
          }
        `}
        render={data => (
                    <section id="two" className="cards-top cards-bg-white">
                        <div className="inner">
                          <header className="major">
                          <h2>{t("beta_title", "WFOW goes beta")}</h2>
                          </header>

                          <p>{t("beta_text1", "WORLD FULL OF WOMEN ist erst seit kurzem online und befindet sich noch in der Entwicklung. Daher kann es leider auch zu Fehlern in der Darstellung oder Logik kommen.")}</p>
                          <p>{t("beta_text2", "Vor jedem Release testen wir natürlich fleißig ... wenn du einen Fehler findest, den wir übersehen haben oder uns einfach nur wertvolles Feedback senden möchtest, kannst du das über den folgenden Button machen.")}</p>

                          <ul className="actions">
                                  <li>
                                  <Link
                                      aria-label="Link to Feedback Page"
                                      to="/feedback"
                                      className="button next"
                                  >
                                      {t("beta_button", "Feedback senden")}
                                  </Link>
                                  </li>
                              </ul>
                      </div>
                    </section>
                )}
            />
        )
    }
} 

export default translate("Index")(Beta)